// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../ASSETS/BACKGROUND/homeHeroBg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cta_cta__o0xU1 {
  background: var(--color-ink) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  isolation: isolate;
}
.cta_cta__o0xU1::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: rgba(18, 21, 26, 0.9);
}
.cta_layout__429OA {
  display: grid;
  gap: var(--space-7);
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
}
.cta_inner__sCo\\+s {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-6);
}
.cta_title__VMu50 {
  margin: 0;
  font-size: var(--text-h1);
  font-weight: 500;
  line-height: var(--leading-heading);
  letter-spacing: var(--tracking-heading);
  text-wrap: balance;
}
.cta_paths__CBx32 {
  display: flex;
  flex-direction: column;
}
.cta_pathsLabel__9Z4Y5 {
  margin: 0 0 var(--space-3);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--color-text-muted-on-dark);
}
.cta_path__pizM9 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.25rem var(--space-4);
  padding: 1.25rem 0;
  border-top: 1px solid var(--color-border-on-dark);
  color: #fff;
  text-decoration: none;
}
.cta_path__pizM9:last-child {
  border-bottom: 1px solid var(--color-border-on-dark);
}
.cta_pathLabel__tOoG8 {
  font-size: var(--text-h3);
  font-weight: 500;
  transition: color var(--dur-fast) ease;
}
.cta_pathText__z1Xf5 {
  grid-column: 1;
  font-size: 0.95rem;
  color: var(--color-text-muted-on-dark);
}
.cta_pathArrow__L\\+bMq {
  grid-column: 2;
  grid-row: 1 / span 2;
  align-self: center;
  font-size: 1.5rem;
  color: var(--kur-gold);
  transition: transform var(--dur-fast) var(--ease-out);
}
.cta_path__pizM9:hover {
  color: #fff;
}
.cta_path__pizM9:hover .cta_pathLabel__tOoG8 {
  color: var(--kur-gold);
}
.cta_path__pizM9:hover .cta_pathArrow__L\\+bMq {
  transform: translateX(6px);
}

@media (min-width: 992px) {
  .cta_layout__429OA {
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);
    gap: var(--space-8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/CTA/cta.module.css"],"names":[],"mappings":"AAAA;EACE,6FAAyG;EACzG,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;EACnC,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qDAAqD;AACvD;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,wDAAwD;IACxD,mBAAmB;EACrB;AACF","sourcesContent":[".cta {\n  background: var(--color-ink) url(\"../../../../ASSETS/BACKGROUND/homeHeroBg.jpg\") center / cover no-repeat;\n  isolation: isolate;\n}\n.cta::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: rgba(18, 21, 26, 0.9);\n}\n.layout {\n  display: grid;\n  gap: var(--space-7);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: center;\n}\n.inner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-6);\n}\n.title {\n  margin: 0;\n  font-size: var(--text-h1);\n  font-weight: 500;\n  line-height: var(--leading-heading);\n  letter-spacing: var(--tracking-heading);\n  text-wrap: balance;\n}\n.paths {\n  display: flex;\n  flex-direction: column;\n}\n.pathsLabel {\n  margin: 0 0 var(--space-3);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--color-text-muted-on-dark);\n}\n.path {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.25rem var(--space-4);\n  padding: 1.25rem 0;\n  border-top: 1px solid var(--color-border-on-dark);\n  color: #fff;\n  text-decoration: none;\n}\n.path:last-child {\n  border-bottom: 1px solid var(--color-border-on-dark);\n}\n.pathLabel {\n  font-size: var(--text-h3);\n  font-weight: 500;\n  transition: color var(--dur-fast) ease;\n}\n.pathText {\n  grid-column: 1;\n  font-size: 0.95rem;\n  color: var(--color-text-muted-on-dark);\n}\n.pathArrow {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  align-self: center;\n  font-size: 1.5rem;\n  color: var(--kur-gold);\n  transition: transform var(--dur-fast) var(--ease-out);\n}\n.path:hover {\n  color: #fff;\n}\n.path:hover .pathLabel {\n  color: var(--kur-gold);\n}\n.path:hover .pathArrow {\n  transform: translateX(6px);\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);\n    gap: var(--space-8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cta": `cta_cta__o0xU1`,
	"layout": `cta_layout__429OA`,
	"inner": `cta_inner__sCo+s`,
	"title": `cta_title__VMu50`,
	"paths": `cta_paths__CBx32`,
	"pathsLabel": `cta_pathsLabel__9Z4Y5`,
	"path": `cta_path__pizM9`,
	"pathLabel": `cta_pathLabel__tOoG8`,
	"pathText": `cta_pathText__z1Xf5`,
	"pathArrow": `cta_pathArrow__L+bMq`
};
export default ___CSS_LOADER_EXPORT___;
